__webpack_require__.p = "/seguros-colectivos/seguro-pyme/_next/";